// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/hooks/usePageStatus.tsx
// v1.4.0 - Added /accessibility-statement to static routes

import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface PageStatus {
  isPublished: boolean;
  isLoading: boolean;
  error: string | null;
}

const STATIC_ROUTES = [
  '/pricing', '/signup', '/verify-email', '/resend-verification',
  '/imprint', '/privacy-policy', '/terms-of-use', '/accessibility-statement',
  '/about', '/careers',
];

export const usePageStatus = (): PageStatus => {
  const location = useLocation();
  const [status, setStatus] = useState<PageStatus>({
    isPublished: true,
    isLoading: true,
    error: null
  });

  useEffect(() => {
    if (STATIC_ROUTES.includes(location.pathname)) {
      setStatus({ isPublished: true, isLoading: false, error: null });
      return;
    }

    const checkStatus = async () => {
      try {
        const path = location.pathname === '/' ? '/' : location.pathname;
        const response = await fetch(`/system/api/v1/website/public/page?path=${encodeURIComponent(path)}`);
        
        if (response.status === 404) {
          setStatus({ isPublished: false, isLoading: false, error: null });
        } else if (response.ok) {
          setStatus({ isPublished: true, isLoading: false, error: null });
        } else {
          setStatus({ isPublished: true, isLoading: false, error: 'API Error' });
        }
      } catch (err) {
        console.warn('Could not check page status:', err);
        setStatus({ isPublished: true, isLoading: false, error: 'Network Error' });
      }
    };

    checkStatus();
  }, [location.pathname]);

  return status;
};

export default usePageStatus;
